import Environment from '../environment/Environment';
import { ObjToQueryString } from '../helpers/Helpers';

import { getRequest, HandlerResponse } from './api';
import { genearteNewToken } from './NewToken.api';

export const GetSalesAnalysisChartData = async (type: string, queryParams?: any) => {
  genearteNewToken();
  const queryString = ObjToQueryString(queryParams);
  return getRequest(`${Environment.API}/rollingplan/graph/salesAnalysis/${type}${queryString}`)
    .then((resp: any) => HandlerResponse(resp));
};

export const GetInventoryAnalysisChartData = async (type: string, queryParams?: any) => {
  genearteNewToken();
  const queryString = ObjToQueryString(queryParams);
  return getRequest(`${Environment.API}/rollingplan/graph/inventoryAnalysis/${type}${queryString}`)
    .then((resp: any) => HandlerResponse(resp));
};

export const GetSalesGrowthAnalysisChartData = async (type: string, queryParams?: any) => {
  genearteNewToken();
  const queryString = ObjToQueryString(queryParams);
  return getRequest(`${Environment.API}/rollingplan/graph/salesGrowthAnalysis/${type}${queryString}`)
    .then((resp: any) => HandlerResponse(resp));
};

export const GetMarginGrowthAnalysisChartData = async (type: string, queryParams?: any) => {
  genearteNewToken();
  const queryString = ObjToQueryString(queryParams);
  return getRequest(`${Environment.API}/rollingplan/graph/marginAnalysis/${type}${queryString}`)
    .then((resp: any) => HandlerResponse(resp));
};
